var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTotalClientes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2.1 TotalClientes") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.1-Dashboard",
    transform: "translate(-581.000000, -248.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy",
    transform: "translate(561.000000, 183.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.1-TotalClientes",
    transform: "translate(20.000000, 65.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.3,
    fill: "#FD9D48",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(15.000000, 11.000000)",
    stroke: "#FE8D27",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4083708,4.76683464 C11.4083708,7.39881174 9.27446374,9.53366928 6.64153613,9.53366928 C4.00955904,9.53366928 1.875652,7.39881174 1.875652,4.76683464 C1.875652,2.13485755 4.00955904,0 6.64153613,0 C9.27446374,0 11.4083708,2.13485755 11.4083708,4.76683464 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.284403,19.2083 L0,19.2083 L0,16.3263374 C0,12.7409933 2.90572552,9.83526782 6.49011903,9.83526782 L6.79333344,9.83526782 C10.3786775,9.83526782 13.284403,12.7409933 13.284403,16.3263374 L13.284403,19.2083 Z",
    id: "Stroke-3"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalClientes);
export default __webpack_public_path__ + "static/media/TotalClientes.4cee72967ed998b4f70e68ca70f3f2c4.svg";
export { ForwardRef as ReactComponent };